/* message event enums */

export const MESSAGE_CREATE_UPDATE_SENDING = 'messages/CREATE_SENDING';
export const MESSAGE_CREATE_UPDATE_SUCCESS = 'messages/CREATE_UPDATE_SUCCESS';
export const MESSAGE_CREATE_UPDATE_FAILURE = 'messages/CREATE_UPDATE_FAILURE';
export const MESSAGE_CREATE_PENDING = 'messages/CREATE_PENDING';
export const MESSAGE_CREATE_PENDING_ATTACHMENTS = 'messages/CREATE_PENDING_ATTACHMENTS';

export const CLEAR_MESSAGES = 'messages/CLEAR_MESSAGES';
export const CLEAR_PENDING_ATTACHMENTS = 'messages/CLEAR_PENDING_ATTACHMENTS';
export const CLEAR_PENDING_MESSAGES = 'messages/CLEAR_PENDING_MESSAGES';

export const UPDATE_CURRENT_PAYMENT_ASSETS = 'messages/UPDATE_CURRENT_PAYMENT_ASSETS';

export const messageEventTypes = {
  MESSAGE_CREATE_UPDATE_START: 'messages/CREATE_START',
  MESSAGE_CREATE_UPDATE_SENDING: 'messages/CREATE_SENDING',
  MESSAGE_CREATE_UPDATE_SUCCESS: 'messages/CREATE_UPDATE_SUCCESS',
  MESSAGE_CREATE_UPDATE_FAILURE: 'messages/CREATE_UPDATE_FAILURE',
  MESSAGE_CREATE_PENDING: 'messages/CREATE_PENDING',
  MESSAGE_CREATE_PENDING_ATTACHMENTS: 'messages/CREATE_PENDING_ATTACHMENTS',
  CLEAR_MESSAGES: 'messages/CLEAR_MESSAGES',
  CLEAR_PENDING_ATTACHMENTS: 'messages/CLEAR_PENDING_ATTACHMENTS',
  CLEAR_PENDING_MESSAGES: 'messages/CLEAR_PENDING_MESSAGES',

  UPDATE_CURRENT_PAYMENT_ASSETS: 'messages/UPDATE_CURRENT_PAYMENT_ASSETS',
};

/* message events */
export const createMessageSending = payload => ({ type: MESSAGE_CREATE_UPDATE_SENDING, payload });
export const clearMessages = () => ({ type: CLEAR_MESSAGES });

export const createAttachmentsPending = payload => ({ type: MESSAGE_CREATE_PENDING_ATTACHMENTS, payload });
export const createMessagePending = payload => ({ type: MESSAGE_CREATE_PENDING, payload });
export const clearPendingAttachments = () => ({ type: CLEAR_PENDING_ATTACHMENTS });
export const clearPendingMessages = () => ({ type: CLEAR_PENDING_MESSAGES });

export const createOrUpdateMessageSuccess = payload => ({ type: MESSAGE_CREATE_UPDATE_SUCCESS, payload });
export const createOrUpdateMessageFailure = (id, errors) => ({
  type: MESSAGE_CREATE_UPDATE_FAILURE,
  payload: { id },
  errors,
});

export const updateCurrentPaymentAssets = payload => ({
  type: UPDATE_CURRENT_PAYMENT_ASSETS,
  payload,
});

export default {
  createMessageSending,
  clearMessages,

  createAttachmentsPending,
  createMessagePending,
  clearPendingAttachments,
  clearPendingMessages,

  createOrUpdateMessageSuccess,
  createOrUpdateMessageFailure,

  updateCurrentPaymentAssets,
};
